import { isHomePageSlug } from "@/constants/homePage";

export function getPagePath(slug?: null | string) {
  if (isHomePageSlug(slug)) return "/";

  return `/${slug}`;
}
